"use client";
import { cn } from "../../lib/utils.js";
import { Separator as Separator$1 } from "radix-ui";
import { jsx } from "react/jsx-runtime";
//#region src/react/shadcn/separator.tsx
function Separator({ className, orientation = "horizontal", decorative = true, ...props }) {
	return /* @__PURE__ */ jsx(Separator$1.Root, {
		"data-slot": "separator",
		decorative,
		orientation,
		className: cn("shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch", className),
		...props
	});
}
//#endregion
export { Separator };

//# sourceMappingURL=separator.js.map